import React, { forwardRef } from "react"
import { Flex, Icon, Modal, Text } from "components/common"
import { useTranslation } from "react-i18next"
import styles from "./index.module.less"
import { Divider } from "antd"
import AppLink from "components/common/layout/app-link"
import { APPSTORE_URL, PLAYSTORE_URL } from "ksa/constants/appLinks"

import {
  BayutPlayStoreArabicIcon,
  BayutAppStoreIcon,
  BayutAppStoreArabicIcon,
  PlayStoreBadgeIcon,
  AppStore,
  GooglePlay,
} from "components/svg"
import { IoCloseOutline } from "react-icons/io5"

const DownloadPopUp = forwardRef((props, ref) => {
  const { t } = useTranslation()

  return (
    <>
      <Modal
        title={t("Get the Bayut Shorakaa App")}
        ref={ref}
        footer={null}
        width={460}
        onCancel={() => {
          ref?.current?.setVisible(false)
        }}
        hideCancelButton={true}
        destroyOnClose
        wrapClassName={styles.downloadAppPopup}
        closeIcon={<IoCloseOutline size="22px" />}
      >
        <Text className="mbe-8 fs16 semiBold">{t("Scan the QR code to download the app")}</Text>

        <Icon icon="BayutQRCode" size="200px" />

        <Divider plain>{t("OR")}</Divider>

        <Flex justify="center" align="center" gap="12px">
          <AppLink
            link={APPSTORE_URL}
            target={"_blank"}
            IconEn={BayutAppStoreIcon}
            IconAr={BayutAppStoreArabicIcon}
            width="110"
            height="34.8"
          />
          <AppLink
            link={PLAYSTORE_URL}
            target={"_blank"}
            IconEn={PlayStoreBadgeIcon}
            IconAr={BayutPlayStoreArabicIcon}
            height="34.8"
          />
        </Flex>
      </Modal>
    </>
  )
})

export default DownloadPopUp
